import type { ObjectHref } from '@bemor/web-kit/ui';

/**
 * BM-46 §2.5: where an object's page is in Admin, for the kit's `ObjectRef` (the kind comes from the public id's
 * prefix). Kinds Admin has no page for link nowhere.
 */
export const adminObjectHref: ObjectHref = (kind, id) => {
    const at = encodeURIComponent(id);
    switch (kind) {
        case 'merchant':
            return `/merchants/${at}`;
        case 'approval':
            return `/approvals/${at}`;
        case 'dispute':
            return `/disputes/${at}`;
        case 'tenant':
            return `/tenants/${at}`;
        case 'case':
            return `/cases/${at}`;
        case 'charge':
            return `/money/charges/${at}`;
        case 'checkout':
            return `/sessions/${at}`;
        // bm-147 § 4 (D-18): web-kit already carries both kinds
        case 'order':
            return `/orders/${at}`;
        case 'subscription':
            return `/subscriptions/${at}`;
        default:
            return null;
    }
};
